import BaseService from "../common/base.service";
import http from "../http-common";

class AttachmentService extends BaseService {
	constructor() {
		super('attachments', {});
	}

	async preUpload(data) {
		return await http.post(`/${this.classPlural}/_preUpload`, data);
	}

	async preDownload(id) {
		return await http.get(`/${this.classPlural}/${id}/_preDownload`);
	}
}

export default new AttachmentService();